export const INSTANCES = {
  GLOBAL: "global",
  AU: "au",
  ID: "id",
  TH: "th",
};

export const checkInstance = (supportedInstance, instance) =>
  supportedInstance.includes(instance);
